import Vue from 'vue'
import Router from 'vue-router'
import mapRoute from './map'
import store from '../vuex/store'
import { initUserInfoBySession } from '../vuex/actions/user_actions'


var oldGo = Router.prototype.go
Router.prototype.go = function(path) {
  if(Vue.util.isObject(path)) {
    if(this.app && this.app.$route.query) {
      path.query = this.app.$route.query
    }
  }
  oldGo.call(this,path)
}

Vue.use(Router);

const router = new Router();
router.beforeEach((transition) => {
  let { to, next } = transition;
  let needLogin = to.login;
  const randomNum = Math.floor(Math.random() * 100000);

  if (!isLogin() && to.name !== 'register' && !to.name.startsWith('wuwei')) {
    initUserInfoBySession(store).then(res => {
      if (res.ok && res.data.errcode === 0 && res.data.data && res.data.data._id) {
        if (!needLogin) {
          // 无需登录的页面(首页/登录页) & 已经登录 则跳转到项目列表页面
          transition.redirect({ name: 'projects' });
        } else {
          next();
        }
      } else {
        to.name === 'login' ? next() : transition.redirect({ name: 'login' });
      }
    }).catch((e) => {
      transition.redirect({ name: 'error' });
    });
  } else {
    next()
  }
});

router.map(mapRoute);

router.redirect({
  '*': '/projects/'
});

function isLogin () {
  return store.state.userInfo._id;
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js